export default __webpack_public_path__ + "static/media/bh7.f752b1c9.jpg";